import { cn } from "helpers/classNames";
import React from "react";

export const Headline6: React.FC<React.ComponentProps<"h5">> = ({
  children,
  className,
  ...props
}) => {
  return (
    <h5
      className={cn(
        `text-xs font-semibold uppercase tracking-tight text-gray-500`,
        className,
      )}
      {...props}
    >
      {children}
    </h5>
  );
};
